import { render } from "./InvoiceCard.vue?vue&type=template&id=214acb4c&scoped=true"
import script from "./InvoiceCard.vue?vue&type=script&lang=js"
export * from "./InvoiceCard.vue?vue&type=script&lang=js"

import "./InvoiceCard.vue?vue&type=style&index=0&id=214acb4c&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214acb4c"]])

export default __exports__